import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "store/store";

import { computeToggledSelection } from "utils/graduationReading";

interface IUserBooksState {
  /** Výběr maturitní četby potvrzený serverem. */
  savedBookIds: string[];
  /** Rozeditovaný výběr — hvězdičky mění jen tohle, dokud student neuloží. */
  draftBookIds: string[];
  isLoaded: boolean;
}

const initialState: IUserBooksState = {
  savedBookIds: [],
  draftBookIds: [],
  isLoaded: false,
};

const userBooksSlice = createSlice({
  name: "userBooks",
  initialState,
  reducers: {
    // Načtení z userBooks i potvrzení mutací userBooksSet — obojí je nový serverem
    // potvrzený stav (mutace posílá celý výběr), takže srovnává i draft: student
    // po uložení nemá nic neuloženého a bublina zmizí.
    setSelection: (state, action: PayloadAction<string[]>) => {
      state.savedBookIds = action.payload;
      state.draftBookIds = action.payload;
      state.isLoaded = true;
    },
    // AIDEV-NOTE: Přepínání počítá reducer z aktuálního stavu, a musí to tak zůstat. Dokud
    // nový seznam skládala komponenta z `draftBookIds` zachyceného při renderu a posílala ho
    // celý, vyšla dvě kliknutí před překreslením ze stejného snímku a to druhé první přepsalo:
    // tři rychlá kliknutí na tři různé knihy zapsala jedinou (naměřeno 19 → 20 místo 19 → 22,
    // se sekundovou pauzou týchž tří kliknutí 19 → 22 správně). [TD-317]
    toggleDraftBook: (state, action: PayloadAction<string>) => {
      state.draftBookIds = computeToggledSelection(state.draftBookIds, action.payload);
    },
  },
});

export default userBooksSlice.reducer;
export const { setSelection, toggleDraftBook } = userBooksSlice.actions;

export const getSavedBookIds = (state: RootState) => state.userBooks.savedBookIds;
export const getDraftBookIds = (state: RootState) => state.userBooks.draftBookIds;
export const isUserBooksSelectionLoaded = (state: RootState) => state.userBooks.isLoaded;
